import React from 'react';
import { Section, SettingsSectionBox, SettingsSectionLabel } from '@views/Settings/components';
import styles from '../Zapier/Zapier.module.scss';
import { useAuthContext } from '@repo/hooks';
import { CopyBtn } from '../CardDav';

export default function Zapier() {
  const { user } = useAuthContext();

  return (
    <Section>
      <SettingsSectionLabel>Make</SettingsSectionLabel>
      <SettingsSectionBox>
        <div className={styles.row}>
          {user.zapier_key}
          <CopyBtn value={user.zapier_key} label="key" />
        </div>
      </SettingsSectionBox>
      <div className={styles.infoText}>
        Make lets you create automations using Clay.{' '}
        <a href="https://www.make.com/en/integrations/clay-earth" target="_blank">
          Click here to add Clay to your Make account
        </a>{' '}
        using the key shown above.
      </div>
      <div className={styles.infoText}>
        Once you've added Clay,{' '}
        <a href="https://go.clay.earth/make-docs" target="_blank">
          follow these instructions
        </a>{' '}
        to get started.
      </div>
    </Section>
  );
}
